import { ColorEnum } from './color.enum';

export type CalendarEventType = 'holiday' | 'absence';

export class CalendarColor {
  private static readonly colorNames: Record<string, string> = {
    [ColorEnum.BLUE]: 'blue',
    [ColorEnum.GREEN]: 'green',
    [ColorEnum.ORANGE]: 'orange',
    [ColorEnum.RED]: 'red',
    [ColorEnum.YELLOW]: 'yellow',
  };

  private static readonly defaultColorName: Record<CalendarEventType, string> =
    {
      holiday: 'green',
      absence: 'orange',
    };

  private static readonly tailwindClasses: Record<string, string> = {
    blue: 'bg-blue-200 text-blue-800',
    green: 'bg-green-200 text-lime-700',
    orange: 'bg-orange-200 text-orange-800',
    red: 'bg-rose-200 text-rose-800',
    yellow: 'bg-yellow-200 text-yellow-800',
  };

  public static getColorClass(
    color: string,
    type: CalendarEventType = 'holiday'
  ): string {
    return `qaroni-${type}-color-${this.getColorName(color, type)}`;
  }

  public static getColorClasses(
    color: string,
    type: CalendarEventType = 'holiday'
  ): string {
    return this.tailwindClasses[this.getColorName(color, type)];
  }

  private static getColorName(color: string, type: CalendarEventType): string {
    return this.colorNames[color] ?? this.defaultColorName[type];
  }
}
